import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-713a947c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "acts" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "item-con"
}
const _hoisted_6 = { class: "db-cell tit" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "main" }
const _hoisted_9 = { class: "db-cell" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "项目名称：", -1))
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "db-cell" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "项目类别：", -1))
const _hoisted_14 = { class: "value" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "db-cell" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "审批事由："),
  /*#__PURE__*/_createElementVNode("div", {
    class: "value",
    style: {"color":"#0077e2"}
  }, "点击卡片查看详情")
], -1))
const _hoisted_16 = { class: "db-cell info" }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "img" }
const _hoisted_19 = { class: "uname" }
const _hoisted_20 = { class: "value" }

import { reactive, ref, onMounted, onActivated } from 'vue'
import { useRouter } from 'vue-router'
import { AppRqeList, getApproveList, getApproveType, getCarbonCopyList } from '@/apis/approval'
import _lodash from '@/utils/lodashUtil'
import { getItemDetail } from '@/apis/projectDetail'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const state = reactive({
  page: 1,
  handleType: 1,
  appType: null,
  orderType: 0,
  tabsActive: 0, // tabs 1
  approvalList: [] as Array<AppRqeList> // 列表数据
})
const loading = ref(false)
const finished = ref(false)
const refreshing = ref(false)

const emptyShow = ref(false) // 展示空状态

const get_approve = async () => {
  let data = {
    page: state.page,
    page_size: 10, //  10条
    handle_type: state.handleType, // 1待办 2已办 3抄送我 4已发起
    type: state.appType, //
    order_type: state.orderType // 0 时间最先 (默认) 1最久等待
  }
  const res = await getApproveList(data)
  if (res.code === 200) {
    finished.value = false
    if (refreshing.value) {
      state.approvalList = []
      refreshing.value = false
    }
    state.page += 1
    state.approvalList = _lodash.uniq(_lodash.concat(state.approvalList, res.data.data))
    if (state.approvalList.length == 0) {
      emptyShow.value = true
    } else {
      emptyShow.value = false
    }

    loading.value = false

    if (state.page > res.data.last_page) {
      finished.value = true
    }
    get_need()
  }
}

const onRefresh = () => {
  emptyShow.value = false
  // 清空列表数据
  finished.value = false
  state.page = 1
  // 重新加载数据
  // 将 loading 设置为 true，表示处于加载状态
  loading.value = true

  get_approve()
}

const get_Carbon_Copy_List = async () => {
  let data = {
    page: state.page,
    page_size: 10, //  10条
    type: state.appType, //
    order_type: state.orderType // 0 时间最先 (默认) 1最久等待
  }
  const res = await getCarbonCopyList(data)
  if (res.code === 200) {
    finished.value = false
    if (refreshing.value) {
      state.approvalList = []
      refreshing.value = false
    }
    state.page += 1
    state.approvalList = _lodash.uniq(_lodash.concat(state.approvalList, res.data.data))

    if (state.approvalList.length == 0) {
      emptyShow.value = true
    } else {
      emptyShow.value = false
    }

    loading.value = false

    if (state.page > res.data.last_page) {
      finished.value = true
    }
  }
}

const onClickTabs = (val: { name: number }) => {
  state.approvalList = []
  if (val.name === 3) {
    console.log('==>onClickTabs', val)
    emptyShow.value = false
    // 清空列表数据
    finished.value = false
    state.page = 1
    // 重新加载数据
    // 将 loading 设置为 true，表示处于加载状态
    loading.value = true
    get_Carbon_Copy_List()
  } else {
    state.handleType = val.name + 1
    onRefresh()
  }
}

const get_approve_Type = async () => {
  const res = await getApproveType()
  if (res.code === 200) {
    Object.keys(res.data).forEach(e => {
      tabFilter.type.push({ text: res.data[e], value: Number(e) })
    })
    localStorage.setItem('operate', JSON.stringify(tabFilter.type))
  }
}

const onChangeMenuType = val => {
  console.log('onChangeMenuType', val)
  if (val == 0) {
    state.appType = null
  } else {
    state.appType = val
  }
  state.approvalList = []
  onRefresh()
}
const onChangeMenuTime = val => {
  console.log('onChangeMenuTime', val)
  state.orderType = val
  state.approvalList = []
  onRefresh()
}

const tabTits = ref([
  { id: 1, name: '待办' },
  { id: 2, name: '已办' },
  { id: 3, name: '已发起' },
  { id: 4, name: '抄送我' }
])

const tabFilter = reactive({
  typeVal: 0,
  type: [
    {
      text: '全部审批',
      value: 0
    }
  ],

  timeVal: 0,
  time: [
    {
      text: '时间最新优先',
      value: 0
    },
    {
      text: '最久等待优先',
      value: 1
    }
  ]
})

// 进入详情页
const goInfo = item => {
  let data = {
    type: item.type,
    item_id: item.item_id
    // project_id: projectinfo.id
  }
  getItemDetail(data).then(res => {
    if (res.code === 200) {
      res.data.tabsActive = state.tabsActive
      res.data.type_id = item.type
      res.data.item_id = item.item_id
      console.log('====>type', res.data)
      let data = JSON.stringify(res.data)
      switch (item.type) {
        case 1:
          router.push('/project/expense-declaration/detail?data=' + data + '&type_name=' + item.type_name + '&button=true')
          break
        case 2:
          router.push('/project/project-termination/detail?data=' + data + '&type_name=' + item.type_name + '&button=true')
          break
        case 3:
          router.push('/project/payment-collection/detail?data=' + data + '&type_name=' + item.type_name + '&button=true')
          break
        case 4:
          router.push('/project/uploadcontract-info?data=' + data + '&type_name=' + item.type_name + '&button=true')
          break
        case 5:
          router.push('/project/replenish-info?data=' + data + '&type_name=' + item.type_name + '&button=true')
          break
        case 6:
          router.push('/project/construction-info?data=' + data + '&type_name=' + item.type_name + '&button=true')
          break
        case 7:
          router.push('/project/sendapply-info?data=' + data + '&type_name=' + item.type_name + '&button=true')
          break
        case 8:
          router.push('/project/acceptance-info?data=' + data + '&type_name=' + item.type_name + '&button=true')
          break
        case 9:
          router.push('/project/completeapply-info?data=' + data + '&type_name=' + item.type_name + '&button=true')
          break
        case 10:
          router.push('/project/schedule-info?data=' + data + '&type_name=' + item.type_name + '&button=true')
          break
        case 11:
          router.push('/project/schedule-info?data=' + data + '&type_name=' + item.type_name + '&button=true')
          break
        case 12:
          router.push('/project/progress-report/detail?data=' + data + '&type_name=' + item.type_name + '&button=true')
          break
        case 13:
          router.push('project/visit-record/detail?data=' + data + '&type_name=' + item.type_name + '&button=true')
          break
        default:
          return
      }
    }
  })
}
const get_need = () => {
  let need = JSON.parse(localStorage.getItem('NEED'))
  if (need == null) {
    need = 0
  }
  tabTits.value[0].name = `待办(${need})`
}

onMounted(() => {
  // get_approve()
  get_need()
  get_approve_Type()
})

onActivated(() => {
  let num = router.currentRoute.value.query.tabsActive
  console.log('===', num)
  if (num) {
    state.tabsActive = Number(num) - 1
    state.handleType = Number(num) ? Number(num) : 1
    state.approvalList = []
    onRefresh()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item")!
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu")!
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_tabs, {
      active: _unref(state).tabsActive,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).tabsActive) = $event)),
      sticky: "",
      onClickTab: onClickTabs
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabTits.value, (e, i) => {
          return (_openBlock(), _createBlock(_component_van_tab, {
            title: e.name,
            key: i
          }, null, 8, ["title"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["active"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_dropdown_menu, null, {
          default: _withCtx(() => [
            _createVNode(_component_van_dropdown_item, {
              modelValue: _unref(tabFilter).typeVal,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(tabFilter).typeVal) = $event)),
              options: _unref(tabFilter).type,
              onChange: onChangeMenuType
            }, null, 8, ["modelValue", "options"]),
            _createVNode(_component_van_dropdown_item, {
              modelValue: _unref(tabFilter).timeVal,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(tabFilter).timeVal) = $event)),
              options: _unref(tabFilter).time,
              onChange: onChangeMenuTime
            }, null, 8, ["modelValue", "options"])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_van_pull_refresh, {
        modelValue: refreshing.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((refreshing).value = $event)),
        onRefresh: onRefresh
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_van_empty, {
            image: "search",
            description: "暂无数据"
          }, null, 512), [
            [_vShow, emptyShow.value]
          ]),
          _createVNode(_component_van_list, {
            class: "list-box",
            loading: loading.value,
            "onUpdate:loading": _cache[3] || (_cache[3] = ($event: any) => ((loading).value = $event)),
            finished: finished.value,
            "finished-text": emptyShow.value ? '' : '没有更多了',
            onLoad: get_approve
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).approvalList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "list-item success",
                  key: index,
                  onClick: ($event: any) => (goInfo(item))
                }, [
                  _createVNode(_component_van_cell_group, { inset: "" }, {
                    default: _withCtx(() => [
                      (_unref(state).approvalList.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("div", _hoisted_7, _toDisplayString(item.type_name), 1),
                              _createElementVNode("div", {
                                class: "value",
                                style: _normalizeStyle(
                      item.state === 0
                        ? 'color:#FF8D1A'
                        : item.state === 1
                        ? 'color:#00BAAD'
                        : item.state === 2
                        ? 'color:#EE1111'
                        : 'color:#A6A6A6'
                    )
                              }, _toDisplayString(item.state_name), 5)
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, [
                                _hoisted_10,
                                _createElementVNode("div", _hoisted_11, _toDisplayString(item.project.name), 1)
                              ]),
                              _createElementVNode("div", _hoisted_12, [
                                _hoisted_13,
                                _createElementVNode("div", _hoisted_14, _toDisplayString(item.project.type_name), 1)
                              ]),
                              _hoisted_15
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, [
                                  _createVNode(_component_van_image, {
                                    round: "",
                                    width: "24",
                                    height: "24",
                                    src: item.staff.avatar
                                  }, null, 8, ["src"])
                                ]),
                                _createElementVNode("div", _hoisted_19, _toDisplayString(item.staff.name), 1)
                              ]),
                              _createElementVNode("div", _hoisted_20, _toDisplayString(item.created_at), 1)
                            ])
                          ]))
                        : (_openBlock(), _createBlock(_component_van_empty, {
                            key: 1,
                            description: "描述文字"
                          }))
                    ]),
                    _: 2
                  }, 1024)
                ], 8, _hoisted_4))
              }), 128))
            ]),
            _: 1
          }, 8, ["loading", "finished", "finished-text"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})